import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { useState } from 'react';
import toast from 'react-hot-toast';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success('Thank you! We will get back to you soon.');
    setForm({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <>
      <div className="page-header">
        <h1>Contact Us</h1>
        <p>Get in touch with our recruitment team</p>
        <div className="breadcrumb">
          <Link to="/">Home</Link> / <span>Contact Us</span>
        </div>
      </div>
      <div className="contact-grid">
        <div className="contact-info">
          <h2>Let's Connect</h2>
          <p>Have questions about our services or want to discuss your recruitment needs? We're here to help.</p>
          <div className="contact-item">
            <div className="icon"><MapPin size={20} /></div>
            <div>
              <h4>Office Address</h4>
              <p>31A, Arawali Apartment,<br />Sector 52, Noida UP<br />201301</p>
            </div>
          </div>
          <div className="contact-item">
            <div className="icon"><Phone size={20} /></div>
            <div>
              <h4>Phone</h4>
              <p>+91 78400 09121</p>
            </div>
          </div>
          <div className="contact-item">
            <div className="icon"><Mail size={20} /></div>
            <div>
              <h4>Email</h4>
              <p>info@careerquess.com</p>
            </div>
          </div>
          <div className="contact-item">
            <div className="icon"><Clock size={20} /></div>
            <div>
              <h4>Working Hours</h4>
              <p>Mon - Sat: 9:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>
        <div className="form-card">
          <h2>Send a Message</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Your Name</label>
              <input type="text" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} required />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} required />
            </div>
            <div className="form-group">
              <label>Subject</label>
              <input type="text" value={form.subject} onChange={(e) => setForm({...form, subject: e.target.value})} required />
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} required />
            </div>
            <button type="submit" className="btn-submit">Send Message</button>
          </form>
        </div>
      </div>
    </>
  );
}
